import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M14.817 2.48a2.502 2.502 0 0 1 2.366 0L27.3 8.012c.662.362 1.065 1.001 1.065 1.69v18.129c0 1.097-1.007 1.986-2.248 1.986H5.884c-1.241 0-2.248-.89-2.248-1.986V9.702c0-.688.403-1.327 1.065-1.689L14.817 2.48Zm.96 1.754a.5.5 0 0 1 .446 0L26.34 9.768a.26.26 0 0 1 .025.015V27.75a.434.434 0 0 1-.248.067h-3.57v-7.09c0-.603-.48-1.092-1.072-1.092h-3.312c-.591 0-1.071.489-1.071 1.091v7.091H14.91v-7.09c0-.603-.48-1.092-1.071-1.092h-3.312c-.592 0-1.071.489-1.071 1.091v7.091h-3.57a.434.434 0 0 1-.249-.067V9.783a.279.279 0 0 1 .025-.015l10.116-5.534Z" clip-rule="evenodd" stroke="none"></path>';
export var MultiFamilyOutlineSVG = function MultiFamilyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
MultiFamilyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MultiFamilyOutlineSVG);